module.exports = __webpack_public_path__ + "img/roundAdd.1775a721.svg";